function keyCreator() {
  return Object.values(arguments).join("_");
}

export default keyCreator;
